// extracted by mini-css-extract-plugin
module.exports = {"submenuChildren":"_b6d68a9","item":"_8f0e48d"};